export const WA_NUMBER_DISPLAY = "+91 84488 20972";
export const WA_NUMBER_RAW = "918448820972";

export const waLink = (msg) =>
  `https://wa.me/${WA_NUMBER_RAW}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_WA_MSG =
  "Hi Anubandh! I saw your website and would like to enquire about gift pricing.";

export const CATEGORIES = [
  {
    id: "bag-set",
    title: "Bag Set",
    hindi: "बैग सेट",
    desc: "Executive crossbodies, backpacks and travel companions in premium vegan leather, made to be carried every day.",
    pages: 36,
    pdf: "/catalogues/anubandh-bags.pdf",
    cover: "/products/bags_p02.jpg",
  },
  {
    id: "desktop-gifts",
    title: "Desktop Gifts",
    hindi: "डेस्कटॉप उपहार",
    desc: "Organiser pads, pen holders and planner sets that bring quiet order to any desk.",
    pages: 26,
    pdf: "/catalogues/anubandh-desktop-gifts.pdf",
    cover: "/products/desktop_p04.jpg",
  },
  {
    id: "table-calendars",
    title: "Table Calendars",
    hindi: "टेबल कैलेंडर",
    desc: "Yoga-inspired table calendars that keep your brand on their desk, month after month.",
    pages: 36,
    pdf: "/catalogues/anubandh-table-calendars.pdf",
    cover: "/products/tc_p03.jpg",
  },
  {
    id: "divine",
    title: "Divine / Bhagwan",
    hindi: "दिव्य भगवान",
    desc: "Hand-finished Lord Ganesha idols in wood and metal, beautifully boxed for auspicious beginnings.",
    pages: 20,
    pdf: "/catalogues/anubandh-divine.pdf",
    cover: "/products/divine_p04.jpg",
  },
  {
    id: "gift-sets",
    title: "Gift Sets",
    hindi: "गिफ्ट सेट्स",
    desc: "Notebook-and-pen combinations and curated daily-use sets, ready to personalise with your brand.",
    pages: 47,
    pdf: "/catalogues/anubandh-gift-sets.pdf",
    cover: "/products/giftsets_p03.jpg",
  },
  {
    id: "premium-gift-sets",
    title: "Premium Gift Sets",
    hindi: "प्रीमियम सेट्स",
    desc: "Rigid boxes with foil-embossed detailing and luxe finishes. Our most lavish collection yet.",
    pages: 172,
    pdf: "/catalogues/anubandh-premium-sets.pdf",
    cover: "/products/premium_p02.jpg",
  },
];

export const MARQUEE_ITEMS = [
  "Bag Set",
  "Desktop Gifts",
  "Table Calendars",
  "Divine Idols",
  "Gift Sets",
  "Premium Gift Sets",
  "अनुबंध",
  "Elevating Every Expression",
];

export const SPOTLIGHT = [
  {
    id: "premium-editorial",
    img: "/products/premium_p03.jpg",
    label: "Premium Gift Sets",
    note: "Foil-embossed rigid boxes",
    span: "md:col-span-7",
    h: "h-80 md:h-[460px]",
  },
  {
    id: "divine-ganesha",
    img: "/products/divine_p12.jpg",
    label: "Divine / Bhagwan",
    note: "Wood & metal idols",
    span: "md:col-span-5",
    h: "h-80 md:h-[460px]",
  },
  {
    id: "bag-crossbody",
    img: "/products/bags_p10.jpg",
    label: "Bag Set",
    note: "Vegan leather crossbodies",
    span: "md:col-span-4",
    h: "h-72 md:h-[380px]",
  },
  {
    id: "desk-organiser",
    img: "/products/desktop_p11.jpg",
    label: "Desktop Gifts",
    note: "Organiser & planner pads",
    span: "md:col-span-4",
    h: "h-72 md:h-[380px]",
  },
  {
    id: "giftset-journal",
    img: "/products/giftsets_p07.jpg",
    label: "Gift Sets",
    note: "Journal & pen duo sets",
    span: "md:col-span-4",
    h: "h-72 md:h-[380px]",
  },
  {
    id: "table-calendar-wide",
    img: "/products/tc_p03.jpg",
    label: "Table Calendars",
    note: "Yoga-themed desk calendars",
    span: "md:col-span-12",
    h: "h-72 md:h-[420px]",
  },
];
